import {Link} from '@primer/react'
import styles from './CopilotDisclosure.module.css'

export function CopilotDisclosure() {
  return (
    <div className={styles.copilotDisclosure}>
      <p className={styles.copilotDisclosureText}>
        <Link
          href="https://docs.github.com/copilot/responsible-use/copilot-coding-agent"
          target="_blank"
          rel="noopener noreferrer"
          muted
          inline
        >
          Copilot
        </Link>{' '}
        uses AI. Check for mistakes.
      </p>
    </div>
  )
}
